import { Link } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import {
  BookOpen,
  CalendarDays,
  Flame,
  FolderKanban,
  ListTodo,
  RefreshCw,
  Sparkles,
  Stamp,
  Target,
} from "lucide-react";
import { useWorkspaceMe } from "./data";
import { WorkDeskHeader } from "./Frame";
import { FocusToday } from "./FocusToday";
import {
  AiContent,
  ApprovalsContent,
  InspirationContent,
  TasksContent,
} from "./WidgetContents";
import {
  DashCard,
  KpiStrip,
  OkrBoard,
  ProjectRisk,
  WeekRhythm,
} from "./DashboardCharts";
import "./dashboard.css";
function todayLine(timezone = "Asia/Shanghai") {
  return new Intl.DateTimeFormat("zh-CN", {
    timeZone: timezone,
    month: "long",
    day: "numeric",
    weekday: "long",
  }).format(new Date());
}
/** 首屏只放「现在要知道的」：指标、今天的重点、等你决定。细节折叠，完整清单去各业务页面。 */
export function DashboardPage() {
  const me = useWorkspaceMe(), client = useQueryClient();
  const timezone = me.data?.data.timezone;
  return (
    <main className="home-page home-standard">
      <WorkDeskHeader
        title={me.data?.data.name ? "你好，" + me.data.data.name : "你好"}
        description={todayLine(timezone)}
        actions={
          <>
            <button
              className="home-quiet dash-icon-button"
              aria-label="刷新工作数据"
              title="刷新工作数据"
              onClick={() =>
                void client.invalidateQueries({
                  queryKey: ["hub", "canonical-data"],
                })}
            >
              <RefreshCw size={15} aria-hidden="true" />
            </button>
            <Link className="home-button" to="/personal-home">去我的主页 ↗</Link>
          </>
        }
      />
      <KpiStrip />
      <div className="dash-grid">
        <div className="dash-main">
          <DashCard
            className="dash-order-1"
            id="standard-focus"
            title="今天先做"
            icon={<Flame size={15} />}
            link={{ to: "/focus", label: "全部重点" }}
          >
            <FocusToday max={3} compact />
          </DashCard>
          <DashCard
            className="dash-order-3"
            id="standard-tasks"
            title="我的待办"
            icon={<ListTodo size={15} />}
            link={{ to: "/tasks", label: "全部任务" }}
          >
            <TasksContent config={{ max: 3, status: "todo" }} />
          </DashCard>
          <DashCard
            className="dash-order-5"
            id="standard-calendar"
            title="本周的安排"
            icon={<CalendarDays size={15} />}
            link={{ to: "/calendar", label: "月历" }}
          >
            <WeekRhythm />
          </DashCard>
        </div>
        <div className="dash-side">
          <DashCard
            className="dash-order-2"
            id="standard-risks"
            title="关注项目的风险"
            icon={<FolderKanban size={15} />}
            link={{ to: "/projects", label: "全部项目" }}
          >
            <ProjectRisk />
          </DashCard>
          <DashCard
            className="dash-order-4"
            id="standard-approvals"
            title="等你决定"
            icon={<Stamp size={15} />}
            link={{ to: "/approvals", label: "审批" }}
          >
            <ApprovalsContent config={{ max: 3 }} />
          </DashCard>
          <DashCard
            className="dash-order-6"
            id="standard-okr"
            title="我的目标"
            icon={<Target size={15} />}
            link={{ to: "/okr", label: "OKR" }}
          >
            <OkrBoard />
          </DashCard>
        </div>
        <DashCard
          className="dash-wide dash-order-7"
          id="standard-activity"
          title="AI 与团队动态"
          icon={<Sparkles size={15} />}
          link={{ to: "/project-agents", label: "项目管家" }}
        >
          <div className="dash-split">
            <section aria-label="AI 今天的动作">
              <AiContent config={{ max: 3, compact: true }} />
            </section>
            <section aria-label="同事分享">
              <h3 className="dash-subhead">同事的分享</h3>
              <InspirationContent required={false} config={{ max: 2 }} />
            </section>
          </div>
        </DashCard>
        <DashCard
          className="dash-wide dash-order-8"
          id="standard-required"
          title="给你的必读"
          icon={<BookOpen size={15} />}
          link={{ to: "/inspiration", label: "灵感墙" }}
        >
          <InspirationContent config={{ max: 3 }} />
        </DashCard>
      </div>
    </main>
  );
}
